import remoteOralExamActions from '../actions/RemoteOralExamActions';
import RemoteOralExamConstants from '../constants/RemoteOralExamConstants';

const defaultState = {
    contextDisplayStatusAcknowledgeSent: false,
    isCandidateJoined: false,
    isSessionCompleted: false,
    sessionInfo: {
        contextDisplayStatus: null,
        contextObjectId: null,
        sessionStatus: null,
        externalResource: {},
        firstName: null,
        evaluatorFirstName: null,
    },
    zoomTestCallDetail: {},
    zoomTestCallStatus: RemoteOralExamConstants.zoomTestCallStatus.NOT_REQUESTED,
    waitingRoom: {
        status: null,
        statusMessage: null,
    },
};

const setSessionInfo = (state, { sessionInfo }) => {
    const updatedSessionInfo = { ...state, sessionInfo: { ...sessionInfo } };
    if (state.sessionInfo?.contextDisplayStatus !== sessionInfo.contextDisplayStatus) {
        updatedSessionInfo.contextDisplayStatusAcknowledgeSent = false;
    }

    return updatedSessionInfo;
};

export default function (state = defaultState, action) {
    switch (action.type) {
    case remoteOralExamActions.types.REMOTE_ORAL_EXAM_SET_SESSION_INFO:
        return setSessionInfo(state, action);
    case remoteOralExamActions.types.REMOTE_ORAL_EXAM_SET_WAITING_ROOM_STATUS:
        return { ...state, waitingRoom: { ...action.data } };
    case remoteOralExamActions.types.REMOTE_ORAL_EXAM_SET_CANDIDATE_JOINED:
        return { ...state, isCandidateJoined: action.isJoined };
    case remoteOralExamActions.types.REMOTE_ORAL_EXAM_SET_SESSION_COMPLETED:
        return { ...state, isSessionCompleted: action.isCompleted };
    case remoteOralExamActions.types.REMOTE_ORAL_EXAM_SET_ZOOM_TEST_CALL_DETAIL:
        return { ...state, zoomTestCallDetail: { ...action.detail } };
    case remoteOralExamActions.types.REMOTE_ORAL_EXAM_SET_ZOOM_TEST_CALL_STATUS:
        return { ...state, zoomTestCallStatus: action.status };
    case remoteOralExamActions.types.REMOTE_ORAL_EXAM_SET_CONTEXT_DISPLAY_STATUS_ACKNOWLEDGE_SENT:
        return { ...state, contextDisplayStatusAcknowledgeSent: action.isSent };
    default:
        return state;
    }
}
